"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScanUploadErrorFolders = exports.RETURNS_REQUEST_SCAN_CENTER_CODES = exports.RETURNS_ALL_SCAN_CENTER_CODES = exports.scanCenterExportPaths = exports.DEFAULT_SCAN_CENTER_CODE = void 0;
const interfaces_1 = require("./interfaces");
exports.DEFAULT_SCAN_CENTER_CODE = interfaces_1.ActiveScanCenterCodeEnum.SPS;
exports.scanCenterExportPaths = {
    [interfaces_1.ActiveScanCenterCodeEnum.ODS]: 'ods/Dokumente',
    [interfaces_1.ActiveScanCenterCodeEnum.SPS]: 'sps/Dokumente',
    [interfaces_1.ActiveScanCenterCodeEnum.SRZ]: 'srz/Lieferungen',
};
exports.RETURNS_ALL_SCAN_CENTER_CODES = [
    interfaces_1.ScanCenterCodeEnum.IAB,
    interfaces_1.ScanCenterCodeEnum.ODS,
    interfaces_1.ScanCenterCodeEnum.SRZ,
];
exports.RETURNS_REQUEST_SCAN_CENTER_CODES = [
    interfaces_1.ScanCenterCodeEnum.ATOS,
    interfaces_1.ScanCenterCodeEnum.SPS,
];
var ScanUploadErrorFolders;
(function (ScanUploadErrorFolders) {
    ScanUploadErrorFolders["DocumentExceedsLimit"] = "DocumentExceedsLimit";
    ScanUploadErrorFolders["GeneralRejects"] = "Rejected";
    ScanUploadErrorFolders["UnSupportedMedia"] = "UnSupportedMedia";
})(ScanUploadErrorFolders || (exports.ScanUploadErrorFolders = ScanUploadErrorFolders = {}));
//# sourceMappingURL=constants.js.map